export default function slugify(
  str,
  customRegex = '',
  customRegexReplace = ''
) {
  if (!str || typeof str !== 'string') return '';

  return (
    !!str &&
    str
      .trim()
      .toLowerCase()
      .replace(customRegex, customRegexReplace)
      .replace(/[“”‘’]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .trim()
  );
}
